(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-print-collection]').forEach(root => {
      if (root.dataset.ready) return;
      const grid = root.querySelector('[data-print-products]');
      const items = [...root.querySelectorAll('[data-print-item]')];
      const filter = root.querySelector('[data-print-filter]');
      const sort = root.querySelector('[data-print-sort]');
      if (!grid || !filter || !sort) return;
      root.dataset.ready = 'true';
      function update() {
        const ordered = [...items].sort((a,b) => {
          if (sort.value === 'price_asc') return Number(a.dataset.price)-Number(b.dataset.price);
          if (sort.value === 'price_desc') return Number(b.dataset.price)-Number(a.dataset.price);
          if (sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          return Number(a.dataset.index)-Number(b.dataset.index);
        });
        let count = 0;
        ordered.forEach(item => {
          item.hidden = !!filter.value && item.dataset.category !== filter.value;
          if (!item.hidden) count++;
          grid.appendChild(item);
        });
        root.querySelector('[data-print-count]').textContent = count === 1 ? root.querySelector('[data-print-single-template]').content.textContent : root.querySelector('[data-print-count-template]').content.textContent.replace('__COUNT__', count);
        root.querySelector('[data-print-empty]').hidden = count !== 0;
      }
      filter.addEventListener('change',update);
      sort.addEventListener('change',update);
      root.querySelector('[data-print-reset]').addEventListener('click',() => {filter.value='';sort.value='featured';update();});
      root.querySelector('.lpc-controls').hidden = false;
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load',() => init());
})();
